import { render, staticRenderFns } from "./MbBadge.vue?vue&type=template&id=fdfa482e&"
import script from "./MbBadge.vue?vue&type=script&lang=js&"
export * from "./MbBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports